/* eslint-disable no-unused-vars */

/**
 * @fileOverview F-elec main JS
 * @author Selectra Front End Team
 * @version 2.2.1
 */


//
// Imports
//

import appLoader from 'design-system/src/js/00-utilities/app-loader';
import getDrupalPaths from 'design-system/src/js/00-utilities/path-utils';
import Collapse from 'design-system/src/js/02-molecules/collapse';
import initAllDropdowns from 'design-system/src/js/01-atoms/dropdown/DropdownManager';
import initCookieCompliance from 'integration-app-config/src/js/03-organisms/cookie-compliance/cookie-compliance';
import initFooter from 'integration-app-config/src/js/03-organisms/footer/footer';
import initMarquee from 'design-system/src/js/02-molecules/marquee';
import initMenu from 'integration-app-config/src/js/03-organisms/menu/menu';
import loadLazyLoading from 'design-system/src/js/00-utilities/lazy-loading';
import loadTooltips from 'design-system/src/js/01-atoms/tooltip';
import Slider from 'design-system/src/js/03-organisms/carousel/slider';
import youtubeEmbed from 'design-system/src/js/00-utilities/youtube-embed';
import Modals from 'design-system/src/js/03-organisms/modal';
import cardToModal from 'integration-app-config/src/js/03-organisms/card-to-modal';
import Checkbox from 'design-system/src/js/01-atoms/checkbox';
import callbackForms from '../03-organisms/callback-forms';
import initCallbackModals from '../03-organisms/callback-modal';


//
// Core
//

// Drupal Paths
const
  {
    drupalBasePath,
    drupalActivePath
  } = getDrupalPaths(),
  polyfillFullPath = evalCorePath( '/js/polyfill/polyfill-full.min.js' ),
  polyfillPartialPath = evalCorePath( '/js/polyfill/polyfill-partial.min.js' );

function evalCorePath( subPath ) {
  let basePath = '/';
  if ( drupalActivePath ) {
    basePath = drupalActivePath;
  } else if ( drupalBasePath ) {
    basePath = drupalBasePath;
  }
  return `${ basePath }${ subPath }`;
}

// App
function app() {

  // Dropdown
  window.selectra.ds.dropdownManager = initAllDropdowns();

  // Tooltip
  loadTooltips();

  // Youtube Embed
  youtubeEmbed();

  // Marquee
  initMarquee({
    marqueeId: 'brands-marquee'
  });

  // Collapse
  new Collapse();

  // Modals
  window.selectra.ds.modals = new Modals();

  // Callback forms
  callbackForms();

  // Checkbox
  new Checkbox();

  // Lazy loading
  loadLazyLoading();

  // Menu
  initMenu();

  // Footer
  initFooter();

  // Cookie compliance
  initCookieCompliance();

  // Reviews carousel
  new Slider({
    selector: '#ac-reviews-carousel',
    responsive: {
      0: {
        controls: false
      },
      992: {
        controls: true,
        controlsAbsolute: true,
        nav: false
      }
    }
  });

  cardToModal();

  // Callback modals
  initCallbackModals( `/${window.drupalSettings.activeThemePath}/js/data/callcenter-ids.json` );
}

// App loader
appLoader({
  appCode: app,
  polyfillUrls: {
    full: polyfillFullPath,
    partial: polyfillPartialPath
  }
});
